import { Component,OnInit,EventEmitter } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {MdSnackBar,MdSnackBarConfig,MdDialog, MdDialogRef} from '@angular/material';
import {Router, ActivatedRoute, Params } from '@angular/router';
import {FormBuilder, Validators } from '@angular/forms';
import {EventService} from '../../event.service';
import {TripService} from '../../trip.service';
import { ExcursionService } from '../../../common/excursion.service';

@Component({
  selector: 'app-trip-edit-activity',
  templateUrl: './trip-edit-activity.component.html',
  styleUrls: ['./trip-edit-activity.component.css','../../admin.css', '../../../app.component.css'],
  providers: [ TripService, EventService, ExcursionService]
})

export class TripEditActivityComponent implements OnInit {
  userId:any;
  eventUserId:any;
  excursionId:any;
  eventId:any;
  users:any;
  userIndex:any;
  spinner:any;
  formChanged:boolean = false;
  excursions = [];

  public onSave = new EventEmitter();
  public onClose = new EventEmitter();

  constructor(private tripService: TripService, private snackBar: MdSnackBar, private excursionService: ExcursionService) { }

  ngOnInit() {
  }

  initiate(){
   this.spinner = true;
   this.eventId = localStorage.getItem('eventId');
   this.tripService.getTripActivityInfo({eventId:this.eventId,eventUserId:this.eventUserId,excursionId:this.excursionId,userId:this.userId}).subscribe(
    response => {
     this.spinner = false;
    },
    error => {
     this.spinner = false;
    }
   );
   this.excursionService.getExcursions(this.eventId).subscribe(
    response => {
     this.excursions = response;
    }
   );
  }

  activityFormValid(frm){
   var flag = true;
   if(this.users[this.userIndex].eventUser.userExcursions)
   {
    this.users[this.userIndex].eventUser.userExcursions.forEach(function(userExcursion){
     if(userExcursion.checked)
     {
      for(var i=0;i<userExcursion.questions.length;i++)
      {
       if(!flag)
       break;
       if(userExcursion.questions[i].isMandatory==1 && (userExcursion.questions[i].answerType=='TextField' || userExcursion.questions[i].answerType=='Radio') && !(userExcursion.userQuestions[i].answerText || userExcursion.userQuestions[i].answerId>0))
       flag = false;
       for(var j=0;j<userExcursion.questions[i].options.length;j++)
       {
        if(!flag)
        break;
        if(userExcursion.questions[i].options[j].id!=userExcursion.userQuestions[i].answerId)
        continue;
        for(var k=0;k<userExcursion.questions[i].options[j].questions.length;k++)
        {
         if(!flag)
         break;
         if(!userExcursion.questions[i].options[j].userQuestions[k])
         continue;
         if(userExcursion.questions[i].options[j].questions[k].isMandatory==1 && (userExcursion.questions[i].options[j].questions[k].answerType=='TextField' || userExcursion.questions[i].options[j].questions[k].answerType=='Radio') && !(userExcursion.questions[i].options[j].userQuestions[k].answerText || userExcursion.questions[i].options[j].userQuestions[k].answerId>0))
         flag = false;
        }
       }
      }
     }
    });
   }
   return flag;
  }

  changeActivity(){
   this.spinner = true;
   this.excursionService.changeActivity({ user:this.users[this.userIndex] }).subscribe(
    response => {
     this.spinner = false;
     if(response.status)
     {
      this.snackBar.open('Excursion Changed Successfully','',{duration:4000});
      this.onSave.emit();
      this.excursionService.changeActivityMail({ mailData:response.mailData }).subscribe();
     }
     else
     this.snackBar.open(response.msg,'',{duration:4000});
    },
    error => {
     this.spinner = false;
     this.snackBar.open(error,'',{duration:4000});
    }
   );
  }

  optionSelected(params){
   for(var i=0;i<params.question.options.length;i++)
   {
    if(params.question.options[i].id==params.optionId && (params.userExcursion.userQuestions[params.questionIndex].answerId==params.optionId || params.question.options[i].selected))
    {
     params.question.options[i].userQuestions = [];
     for(var j=0;j<params.question.options[i].questions.length;j++)
     params.question.options[i].userQuestions.push({id:'', userId:params.userExcursion.userId, excursionQuestionId:params.question.options[i].questions[j].id, answerId:0, answerText:''});
    }
   }
   if(params.userExcursion.price)
   this.setPrice(params);
  }

  setPrice(params){
    params.userExcursions.userQuestions[params.questionIndex].price = 0.00;
    for(var i=0;i<params.question.options.length;i++)
    {
      for(var j=0;j<params.question.options[i].userQuestions.length;j++)
        params.question.options[i].userQuestions[j].price = 0.00;
      if(params.userExcursions.userQuestions[params.questionIndex].answerId==params.question.options[i].id || params.question.options[i].selected)
      {
        if(params.question.options[i].isPrice)
        {
          if(params.question.answerType=='Radio')
            params.userExcursions.userQuestions[params.questionIndex].price = parseFloat(params.question.options[i].price);
          else if(params.question.answerType=='Check')
            params.userExcursions.userQuestions[params.questionIndex].price += parseFloat(params.question.options[i].price);
        }
      }
    }
  }

  subOptionSelected(params){
    if(params.userExcursions.price)
      this.setSubPrice(params)
  }

  setSubPrice(params){
    params.option.userQuestions[params.questionIndex].price = 0.00;
    for(var i=0;i<params.question.options.length;i++)
    {
      if(params.option.userQuestions[params.questionIndex].answerId==params.question.options[i].id || params.question.options[i].selected)
      {
        if(params.question.options[i].isPrice)
        {
          if(params.question.answerType=='Radio')
            params.option.userQuestions[params.questionIndex].price = parseFloat(params.question.options[i].price);
          else if(params.question.answerType=='Check')
            params.option.userQuestions[params.questionIndex].price += parseFloat(params.question.options[i].price);
        }
      }
    }
  }

  assignUserExcursions(user){
   user.eventUser.userExcursions = [];
   for(var i=0;i<this.excursions.length;i++)
   user.eventUser.userExcursions.push({
    userId : '',
    eventId : user.eventUser.eventId,
    excursionId : this.excursions[i].id,
    checked : false,
    questions : [],
    userQuestions : []
   });
  }

  excursionSelected(userExcursion){
   this.spinner = true;
   userExcursion.userQuestions = [];
   userExcursion.questions = [];
   if(userExcursion.checked)
   {
    for(var i=0;i<this.excursions.length;i++)
    if(this.excursions[i].id==userExcursion.excursionId)
    {
     userExcursion.excursionName = this.excursions[i].name;
     break;
    }
    this.excursionService.getExcursionQuestionsWithOptions({excursionId:userExcursion.excursionId}).subscribe(
     response => {
      this.spinner = false;
      userExcursion.questions = response;
      userExcursion.userQuestions = [];
      for(var i=0;i<userExcursion.questions.length;i++)
      {
       userExcursion.questions[i].isMandatory = parseInt(userExcursion.questions[i].isMandatory);
       userExcursion.userQuestions.push({id:'', userId:userExcursion.userId, excursionQuestionId:userExcursion.questions[i].id, answerId:0, answerText:''});
       for(var j=0;j<userExcursion.questions[i].options.length;j++)
       for(var k=0;k<userExcursion.questions[i].options[j].questions.length;k++)
       userExcursion.questions[i].options[j].questions[k].isMandatory = parseInt(userExcursion.questions[i].options[j].questions[k].isMandatory);
      }
     },
     error => {
      this.spinner = false;
     }
    );
   }
   else
   this.spinner = false;
  }

    reset(){
        this.onClose.emit();
    }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/trip/trip-edit-activity/trip-edit-activity.component.ts